import React from 'react';
import mederiLogo from './mederi-logo.svg';
import './MederiAdminBrand.css';

type MederiAdminBrandProps = {
  variant?: 'light' | 'dark';
};

export const MederiAdminBrand: React.FC<MederiAdminBrandProps> = ({ variant = 'light' }) => (
  <span className={`mederi-admin-brand mederi-admin-brand--${variant}`} role="img" aria-label="mederi admin">
    <img src={mederiLogo} alt="" />
    <span className="mederi-admin-brand-label" aria-hidden="true"><span className="mederi-admin-brand-text">admin</span></span>
  </span>
);
